/**
 * 预习卡（家长端）—— `/students/:id/dictation/:sessionId/preview`。
 *
 * ## 实现全在 `components/dictation/DictationPreviewPanel.tsx`
 *
 * 2026-10-28 用户要求孩子端也要同一个入口：
 *
 * > "家长端布置完听写任务并点击听写，右上角有一个"先预习"的功能。
 * >  我觉得孩子那边也要加一个这个入口，在听写之前，他可以先预习，点进去预习。"
 *
 * 于是那一页从"家长页面"抽成了**两端共用的面板**（差别只有外壳、链接、
 * 以及孩子端没有"看全部题目"这一项）。这一页只剩三件事：
 * 从路由里取 `id` / `sessionId`、拼出两条链接、交给面板。
 *
 * ⚠️ 为什么不合并成一条路由：家长端的数据在 `/students/:id/...`（`resolveStudentAccess`
 *    认 parent/student），孩子端在 `/student/...`（自己解析出 student.id）。
 *    两条路径就是两套 id 空间，合并只会让"这个 id 是哪个空间"重新变成猜。
 */
import { useParams } from 'react-router-dom';
import { DictationPreviewPanel } from '../../components/dictation/DictationPreviewPanel';

export function ParentDictationPreviewPage() {
  const { id = '', sessionId = '' } = useParams<{ id: string; sessionId: string }>();

  return (
    <DictationPreviewPanel
      kind="parent"
      studentId={id}
      sessionId={sessionId}
      playerHref={`/students/${id}/dictation/${sessionId}`}
      listHref={`/students/${id}/dictation`}
      reviewHref={`/students/${id}/dictation/${sessionId}/review`}
      playerHint="回上一页点「开始播放」"
    />
  );
}
